import http from 'common/http'
import {
  clientCreated,
  clientsFetched,
  clientEdited,
  clientDeleted,
  farmReferencesUpdated,
  assignSelectedClient,
} from 'actions/client'
import { farmsUpdated, assignSelectedFarms } from 'actions/farm'
import { closeModal } from 'actions/app'
import { getClientFarm } from 'common/misc'
import { get, isEmpty } from 'es-toolkit/compat'
import store from 'store/index'

export const createClient = (data) => {
  return (dispatch) => {
    return http.post('/client', data).then((res) => {
      dispatch(clientCreated(res.data))
      dispatch(closeModal())

      dispatch(assignSelectedFarms([]))
      return {
        data: res.data,
        message: 'Client created',
      }
    })
  }
}

export const getClients = () => {
  return (dispatch) => {
    return http.get('/client').then((res) => {
      dispatch(clientsFetched(res.data.results))
      const account = get(store.getState(), 'account.singleton', {})
      if (!isEmpty(account)) {
        const cffPrefDefault = account?.prefs?.cff
        //@ts-ignore
        const { client, selectedFarms } = getClientFarm(
          cffPrefDefault?.enabled,
          res.data.results,
          cffPrefDefault?.client,
        )
        dispatch(assignSelectedClient(client))

        dispatch(
          assignSelectedFarms(selectedFarms?.length ? selectedFarms : []),
        )
      }
    })
  }
}

export const getClientsPaginated = (
  page = 1,
  pageSize = 10,
  search = '',
  showArchivedClients = false,
) => {
  return (dispatch: any) => {
    const params = { page, pageSize }
    if (search) {
      params['search'] = search
    }
    if (showArchivedClients) {
      params['archived'] = true
    }
    return http.get('/client', { params })
  }
}

export const editClient = (data) => {
  return (dispatch) => {
    const clientId = data.id
    return http.put(`/client/${clientId}`, data).then((res) => {
      dispatch(clientEdited(res.data))
      dispatch(closeModal())
    })
  }
}

export const deleteClient = (id) => {
  return (dispatch) => {
    return http.delete(`/client/${id}`).then(() => {
      dispatch(clientDeleted(id))
      dispatch(closeModal())
    })
  }
}

export const assignFarms = (data) => {
  const { selectedClient, selectedIds } = data
  return (dispatch) => {
    return http
      .post(`/client/${selectedClient}/farms`, selectedIds)
      .then((res) => {
        dispatch(closeModal())
        dispatch(farmsUpdated(res.data))
        //For updating the client to show the updated farms
        dispatch(farmReferencesUpdated(data))
      })
  }
}

export const archiveClients = (data) => {
  return (dispatch) => {
    return http.post(`/client/archive/`, data).then(() => {
      for (const id of data.clientIds) {
        dispatch(clientDeleted(id))
      }
      dispatch(closeModal())
    })
  }
}

export const restoreClients = (data, callback) => {
  return (dispatch) => {
    return http.post(`/client/restore/`, { clientIds: data }).then((res) => {
      for (const client of res.data?.clients || []) {
        dispatch(clientCreated(client))
      }
      if (callback) {
        callback()
      }
      dispatch(closeModal())
    })
  }
}

export const deleteClients = (data, callback) => {
  return (dispatch) => {
    return http.delete(`/client/delete-multiple/${data}`).then(() => {
      if (callback) {
        callback()
      }
      dispatch(closeModal())
    })
  }
}
